import { IStoreState, Selector } from '../types';

export const selectSelectedRestaurantId: Selector<string> = (state: IStoreState) => state.auth.selectedRestaurantId;
export const selectToken: Selector<string> = (state: IStoreState) => state.auth.token;
